import toast from 'react-hot-toast';
import web from './web';

export default function callCenterBooking() {
    return {
        price: false,
        type: false,
        loading: false,
        refreshPrice(e) {
            this.price = e.target.querySelector('option:checked').getAttribute('data-price') || false;
        },
        async submit(event, specialty_id) {
            event.preventDefault();
            if (this.loading || (event.type == 'click' && !this.$root.reportValidity())) return;
            this.loading = true;
            const formData = new FormData(this.$root);
            if (specialty_id) {
                formData.set('specialty_id', specialty_id);
            }
            try {
                const response = await web.post('home', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.message) {
                    toast.success(response.data.message);
                    this.$root.querySelector('[name="query"]').value = '';
                    this.$root.querySelector('[name="city_id"]').value = '';
                    this.$root.querySelector('[name="district_id"]').value = '';
                    this.$root.querySelector('[name="video"]').value = '';
                    this.$root.querySelector('[name="observations"]').value = '';
                    if (this.type == 'specialty') {
                        this.$root.querySelector('[name="specialty_id"]').value = '';
                    }
                } else {
                    toast.error(error.response.data.message);
                }
            } catch (error) {
                if (error.response.status == 401) {
                    window.location.href = '/login';
                } else {
                    toast.error(error.response.data.message);
                }
            } finally {
                this.loading = false;
                this.type = false;
            }
        },
    };
}

const paymentSection = document.querySelector('[data-payment]');
if (paymentSection) {
    try {
        const appointmentId = paymentSection.getAttribute('data-appointment-id');
        const manifest = JSON.parse(paymentSection.getAttribute('data-manifest'));

        const checkoutInstance = easypayCheckout.startCheckout(manifest, {
            // display: 'popup',
            testing: window.APP_ENV == 'production' ? false : true,
            language: document.documentElement.lang == 'pt' ? 'pt_PT' : 'en',
            onSuccess: (response) => {
                console.log(response);
            },
            onError: (error) => {
                console.error(error);
            },
            onClose: () => {
                checkoutInstance.unmount();
                window.location.href = `/upcoming?check=${appointmentId}`;
            },
        });
    } catch (error) {
        console.log(error);
    }
}
